module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "multipicker-view"
  }, [_c('p', [_vm._v(_vm._s(_vm.city))]), _vm._v(" "), _c('VwButton', {
    attrs: {
      "plain": "",
      "id": "picker-trigger"
    }
  }, [_vm._v("Multi picker")]), _vm._v(" "), _c('Picker', {
    attrs: {
      "picker-id": "picker-trigger",
      "select-list": _vm.cityList
    },
    on: {
      "change": _vm.selectCity
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-c96a8580!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/multiPickerView.vue
// module id = 286
// module chunks = 0